module.exports = __webpack_public_path__ + "img/seminar_symposium.33b88acc.jpg";